import { Injectable } from '@angular/core';
import { DadoFinanceiroDto } from '../../dtos'
import { CaqRequestService } from '../'
import { map, firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

interface DadoFinanceiroResponse {
  _embedded: {
    'dado-financeiro': DadoFinanceiroDto[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class DadoFinanceiroService {
  public urlBase = `${environment.apiUrl}/dados-financeiros`;

  constructor(private caqRequestService: CaqRequestService) {}

  async buscarDadoFinanceiro(): Promise<DadoFinanceiroDto[]> {
    return firstValueFrom(this.caqRequestService
      .get<[DadoFinanceiroDto]>(this.urlBase)
      .pipe(map((response) => {
        return response
      })));
  }
}
